import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import useIsMobile from 'utils/isMobileUtils';
import StatusBadge from 'ui-component/StatusBadge';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';

// ✅ Clear
const Summary = ({ operationDetails }) => {
    const [summaryDetails, setSummaryDetails] = useState([]);
    const isMobile = useIsMobile();

    useEffect(() => {
        const summaryMap = {};
        operationDetails?.products?.forEach(product => {
            const key = `${product.product_name}-${product.color_name}`;
            if (summaryMap[key]) {
                summaryMap[key].quantity += product.quantity;
            } else {
                summaryMap[key] = {
                    name: product.product_name,
                    color: product.color_name,
                    quantity: product.quantity
                };
            }
        });
        setSummaryDetails(Object.values(summaryMap));
    }, [operationDetails]);

    return (
		<div className={`${!isMobile ? '' : 'm-0 p-3 p-xl-4 w-100 new-card'}`}>
			<div className={`${isMobile ? '' : "form-group"}`}>
				<h5 style={{ marginLeft: isMobile ? '' : '10px', marginTop: isMobile ? '' : '10px' }}>Summary</h5>
			</div>
			<div>
				{summaryDetails?.length > 0 ? (
					isMobile ? (
						<div>
							{summaryDetails.map((product, index) => (
								<div
									key={index}
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										padding: '12px 0',
										borderBottom: '1px solid #eee',
										background: '#fff'
									}}
								>
									<div>
										<div style={{ fontWeight: 500 }}>{product.name}</div>
										{product?.color && <div className="textGray">{product.color}</div>}
									</div>
									<div style={{ fontWeight: 600, minWidth: 60, textAlign: 'right' }}>
										{parseInt(product.quantity).toLocaleString()} pcs
									</div>
								</div>
							))}
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									padding: '12px 0',
									fontWeight: 600
								}}
							>
								<div>Total</div>
								<div>{parseInt(summaryDetails.reduce((acc, product) => acc + parseInt(product.quantity), 0)).toLocaleString()} pcs</div>
							</div>
						</div>
					) : (
						<>
							<div className="row" style={{ padding: '0 10px', marginBottom: '5px' }}>
								<div className="col-12 mb-1 flex justify-content-between">
									<div className="flex" style={{ alignItems: 'center' }}>Status</div>
									<div style={{ marginTop: '-7px' }}>
										<StatusBadge itemStatus={operationDetails?.status !== '' ? operationDetails?.status : 'Draft'} />
									</div>
								</div>
							</div>
							<div className="row" style={{ padding: '0 10px', marginBottom: '5px' }}>
								<div className="col-12 mb-1 flex justify-content-between">
									<div className="flex" style={{ alignItems: 'center' }}>Purchase Order</div>
									<div>
										{
											operationDetails?.purchaseOrderNumber ? (
												<Link to={`/purchasing/view/${operationDetails?.purchaseInvoiceId}`} target="_blank">
													<PrivacyModeContent>{ operationDetails?.purchaseOrderNumber }</PrivacyModeContent>
												</Link>
											) : (
												<span className="text-gray-600">------</span>
											)
										}
									</div>
								</div>
							</div>
							<div className="row" style={{ padding: '0 10px', marginBottom: '5px' }}>
								<div className="col-12 mb-1 flex justify-content-between">
									<div className="flex" style={{ alignItems: 'center' }}>Supplier</div>
									<div>
										{
											operationDetails?.supplier?.id ? (
												<Link to={`/contacts/${operationDetails?.supplier?.id}`} target="_blank">
													<PrivacyModeContent>{operationDetails?.supplier?.name}</PrivacyModeContent>
												</Link>
											) : (
												<span className="text-gray-600">------</span>
											)
										}
									</div>
								</div>
							</div>
							<div className="row" style={{ padding: '0 10px', marginBottom: '5px' }}>
								<div className="col-12 mb-1 flex justify-content-between">
									<div className="flex" style={{ alignItems: 'center' }}>Invoice</div>
									<div>
										{
											operationDetails?.invoice?.id ? (
												<Link to={`/sales/invoices/${operationDetails?.invoice?.id}`} target="_blank">
													{operationDetails?.invoice?.invoice_number}
												</Link>
											) : (
												<span className="text-gray-600">------</span>
											)
										}
									</div>
								</div>
							</div>
							<div className="row" style={{ padding: '0 10px', marginBottom: '5px' }}>
								<div className="col-12 mb-1 flex justify-content-between">
									<div className="flex" style={{ alignItems: 'center' }}>Sales Order</div>
									<div>
										{
											operationDetails?.sales_order?.id ? (
												<Link to={`/sales/sales-orders/${operationDetails?.sales_order?.id}`} target="_blank">
													{operationDetails?.sales_order?.sales_order_number}
												</Link>
											) : (
												<span className="text-gray-600">------</span>
											)
										}
									</div>
								</div>
							</div>
							<table className="table pm-table">
								<thead>
									<tr>
										<th scope="col">Product</th>
										<th scope="col" style={{ width: '80px' }}>
											Qty
										</th>
									</tr>
								</thead>
								<tbody>
									{summaryDetails.map((product, index) => (
										<tr key={index}>
											<td>
												<div>{product.name}</div>
												{product?.color && <div className="textGray">{product.color}</div>}
											</td>
											<td>{parseInt(product.quantity).toLocaleString()}</td>
										</tr>
									))}
								</tbody>
								<tfoot>
									<tr>
										<td className="font600">Total</td>
										<td className="font600">
											{parseInt(summaryDetails.reduce((acc, product) => acc + parseInt(product.quantity), 0)).toLocaleString()} pcs
										</td>
									</tr>
								</tfoot>
							</table>
						</>
					)
				) : (
					<div className="not-found-container cstm-not-found" style={{ height: '300px' }}>
						<div className="not-found-icon">
							<img src={NoRecordFoundIcon} style={{ height: '100px', width: '100px' }} />
						</div>
						<h6 className="not-found-text">Summary unavailable</h6>
					</div>
				)}
			</div>
		</div>
	);
};

export default Summary;
